import {Component, OnInit, ViewChild} from '@angular/core';
import {AbstractControl, FormControl, FormGroup, ValidatorFn, Validators} from "@angular/forms";
import {concat, map, Observable, ObservableInput, startWith} from "rxjs";
import {MatTableDataSource} from "@angular/material/table";
import {FabDateFilterOperator, FabStringFilterOperator} from "@fabric/components/table-filter";
import {
  DestinatarioBriefModel,
  IdDescModel,
  RemitoVehicleCreationDetails
} from "../../models/RemitoVehicleCreationDetails";
import {RemitoVehicleService} from "../../services/remito-vehicle.service";
import {VehOnhold} from "../../models/VehOnhold";
import {FabTableState, filterStateChange, process} from "@fabric/components/table-filter/data-query";
import {NotificationService} from "../../services/notification.service";
import {MatPaginator} from "@angular/material/paginator";
import {ErrorCodes} from "../../constants/ErrorCodes";
import {HttpErrorResponse} from "@angular/common/http";
import {MatSort} from "@angular/material/sort";
import {VehicleOnHoldService} from "../../services/veh-onHold.service";
import {
  PopupFileUploadMessageDialogComponent,
  SCREEN
} from "../../shared-components/popup-file-upload-message-dialog/popup-file-upload-message-dialog.component";
import {MatDialog} from "@angular/material/dialog";
import {OnHoldUploadResults} from "../../models/OnHoldUploadResults";


@Component({
  selector: 'app-vehicle-onhold-release',
  templateUrl: './vehicle-onhold-release.component.html',
  styleUrls: ['./vehicle-onhold-release.component.scss']
})
export class VehicleOnholdReleaseComponent implements OnInit {

  displayedColumns: string[] = [
    'vinLetras', 'vinNumeros', 'fecGen', 'chargeToCode', 'codDestino', 'nombreDestino',
    'invoiceLetter', 'invoicePto', 'invoiceNum', 'billingType', 'releaseButton'
  ];
  dataSource: MatTableDataSource<VehOnhold> = new MatTableDataSource<VehOnhold>();
  createDetailsData: RemitoVehicleCreationDetails[] = [];
  onholdItems: VehOnhold[] = [];
  @ViewChild(MatPaginator) private paginator: MatPaginator;

  @ViewChild(MatSort) set matSort(sort: MatSort) {
    this.dataSource.sort = sort;
  }

  showOnholdData: boolean = false;
  operators: FabStringFilterOperator[] = ['contains'];
  public dateOperators: FabDateFilterOperator[] = ['eq', 'gte', 'lte'];
  state: FabTableState = {
    skip: 0,
    take: 5,
    filter: [],
    sort: []
  };
  errors: HttpErrorResponse[] = [];
  vinLetrasControl = new FormControl<string>('', [Validators.pattern("[a-zA-Z0-9 ]*")]);
  vinNumerosControl = new FormControl<string>('',  [Validators.pattern("^[0-9]*$")]);
  fecGenControl = new FormControl<Date | null>(null);
  destinatarioControl = new FormControl<string | DestinatarioBriefModel>('')
  chargeToControl = new FormControl<string | IdDescModel>('');

  onholdReleaseVehRemForm: FormGroup = new FormGroup({
    vinLetras: this.vinLetrasControl,
    vinNumeros: this.vinNumerosControl,
    fecGen: this.fecGenControl,
    destinatario: this.destinatarioControl,
    chargeTo: this.chargeToControl
  })

  filteredDestinatario: Observable<DestinatarioBriefModel[]> | undefined;
  filteredChargeTo: Observable<IdDescModel[]> | undefined;
  destinatario: DestinatarioBriefModel[] = [];
  chargeTo: IdDescModel[] = [];

  validDestinatario: string[] = [];
  validChargeTo: string[] = [];

  vehOnHold: VehOnhold;
  printExcel: boolean = false;
  validationErrorMessage: string = '';
  isLoading: boolean = false;

  constructor(private remitoVehicleService: RemitoVehicleService, private notificationService: NotificationService,
              private vehicleOnHoldService: VehicleOnHoldService,
              private dialog: MatDialog) { }

  ngOnInit(): void {
    this.fetchData();
  }

  fetchData() {
    let obs: ObservableInput<any>[] = [];
    obs.push(this.remitoVehicleService.getDetails("A").pipe(map((response) => {
      if (response) {
        // @ts-ignore
        this.createDetailsData = response;
        // this.dataSource = new MatTableDataSource<RemitoVehicleCreationDetails>(this.createDetailsData);
        for (let i = 0; i < response.destinatario.length; i++) {
          this.destinatario.push(response.destinatario[i]);
          this.validDestinatario.push(response.destinatario[i].id + ' - ' + response.destinatario[i].desc);
        }
        this.validDestinatario.push('');
        this.populateDestinatario();
        for (let i = 0; i < response.chargeTo.length; i++) {
          this.chargeTo.push(response.chargeTo[i]);
          this.validChargeTo.push(response.chargeTo[i].id + ' - ' + response.chargeTo[i].desc);
        }
        this.validChargeTo.push('');
        this.populateChargeTo();
      }
    })));
    concat(...obs).subscribe({
      next: undefined,
      error: undefined,
      complete: () => {
        this.addValidators()
      }
    });
  }

  addValidators() {
    this.destinatarioControl.addValidators([VehicleOnholdReleaseComponent.checkInValidList(this.validDestinatario)]);
    this.destinatarioControl.updateValueAndValidity();
  }

  public static checkInValidList(validList: string[]): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      return validList.includes(control.value) ? null : {'in-valid-list': true};
    }
  }

  populateDestinatario() {
    this.filteredDestinatario = this.destinatarioControl.valueChanges.pipe(
      startWith(''),
      map(value => {
        const destinatarioValue = typeof value === 'string' ? value : value?.desc;
        return destinatarioValue ? this.destinatarioFiltering(destinatarioValue as string) : this.destinatario.slice();
      }),
    );
  }

  populateChargeTo() {
    this.filteredChargeTo = this.chargeToControl.valueChanges.pipe(
      startWith(''),
      map(value => {
        const chargeToValue = typeof value === 'string' ? value : value?.desc;
        return chargeToValue ? this.chargeToFiltering(chargeToValue as string) : this.chargeTo.slice();
      }),
    );
  }

  private destinatarioFiltering(name: string): DestinatarioBriefModel[] {
    const filterValue = name.toLowerCase();
    return this.destinatario.filter(option => option.desc.toLowerCase().includes(filterValue) || option.id.toLowerCase().includes(filterValue));
  }

  private chargeToFiltering(name: string): IdDescModel[] {
    const filterValue = name.toLowerCase();
    return this.chargeTo.filter(option => option.desc.toLowerCase().includes(filterValue) || option.id.toLowerCase().includes(filterValue));
  }

  print() {
    this.isLoading = true;
    this.printExcel = true;
    this.search();
  }

  search() {
    this.getSearchData();
    this.validateSearchData();

    if (this.validationErrorMessage != '' && !this.printExcel) {
      this.notificationService.open(this.validationErrorMessage, 'error');
      this.isLoading = false;
    } else if (this.onholdReleaseVehRemForm.invalid) {
      this.notificationService.open("Campos de búsqueda Inválido. Por favor complete los campos requeridos", 'error');
      this.isLoading = false;
    } else if(this.validationErrorMessage === 'Ingrese al menos UN criterio de búsqueda válido para continuar!' && this.printExcel) {
      this.checkPrintExcel(true); // Do not display data, but still print Excel
    } else {
      this.vehicleOnHoldService.getAllOnHoldRemitos(this.vehOnHold).subscribe((response) => {
        this.onholdItems = response;
        this.displayData();
        this.checkPrintExcel(false);
      });
    }
  }

  displayData() {
    if (this.onholdItems.length == 0) {
      //No results found related to your search, Please try different criteria.
      this.notificationService.open('No se encuentran resultados para la búsqueda. Por favor seleccione criterios diferentes.', 'warn');
      this.hideTable();
    } else {
      this.dataSource.data = process(this.onholdItems as any[], this.state);
      this.showOnholdData = true;
      this.setPagination();
    }
  }

  getSearchData() {
    this.vehOnHold = new VehOnhold();
    this.vehOnHold.ptoEmision = null;
    this.getVinSearchCriteria();
    this.getDestinatarioSearchCriteria();
    this.getChargeToSearchCriteria();
    this.getFecGenSearchCriteria();
  }

  getVinSearchCriteria() {
    //vin letras
    if (this.vinLetrasControl.value == null || this.vinLetrasControl.value == '') {
      this.vehOnHold.vinLetras = null;
    } else {
      this.vehOnHold.vinLetras = this.vinLetrasControl.value;
    }

    //vin numeros
    if (this.vinNumerosControl.value == null || this.vinNumerosControl.value == '') {
      this.vehOnHold.vinNumeros = null;
    } else {
      this.vehOnHold.vinNumeros = this.vinNumerosControl.value;
    }

  }

  getDestinatarioSearchCriteria() {
    if (this.destinatarioControl.value != '' && this.destinatarioControl.value != '-1') {
      // @ts-ignore
      var [cod_destino, ...nombre_destino] = this.destinatarioControl.value.split('-');
      this.vehOnHold.codDestino = cod_destino;
      this.vehOnHold.nombreDestino = nombre_destino.join('-');
    } else {
      this.vehOnHold.codDestino = null;
      this.vehOnHold.nombreDestino = null;
    }
  }

  getChargeToSearchCriteria() {
    if (this.chargeToControl.value != '' && this.chargeToControl.value != null) {
      // @ts-ignore
      var [cod_chargeTo, ...nombre_chargeTo] = this.chargeToControl.value.split('-');
      this.vehOnHold.chargeToCode = cod_chargeTo;
      this.vehOnHold.chargeToName = nombre_chargeTo.join('-');
    } else {
      this.vehOnHold.chargeToCode = null;
      this.vehOnHold.chargeToName = null;
    }
  }

  getFecGenSearchCriteria() {
    if (this.fecGenControl.value == null) {
      this.vehOnHold.fecGen = null;
    } else {
      // @ts-ignore
      this.vehOnHold.fecGen = this.fecGenControl.value.toISOString().slice(0, 10);
    }
  }

  validateSearchData() {

    this.validationErrorMessage = '';

    if (this.vehOnHold.codDestino == null && this.vehOnHold.vinLetras == null && this.vehOnHold.vinNumeros == null
      && this.vehOnHold.fecGen == null && this.vehOnHold.chargeToCode == null) {

      this.validationErrorMessage = 'Ingrese al menos UN criterio de búsqueda válido para continuar!';
      this.hideTable();
    }
  }

  public filterChange(event: any) {
    this.state.skip = 0;
    // @ts-ignore
    this.state.filter = filterStateChange(event, this.state.filter);
    this.filterData();
  }

  private filterData() {
    this.dataSource.data = process(this.onholdItems, this.state)
  }

  hideTable() {
    this.showOnholdData = false;
    this.dataSource.data = [];
  }

  releaseOnhold(vehOnholdRow: VehOnhold) {
    this.vehicleOnHoldService.releaseAutomaticOnholdVehRemitos(vehOnholdRow.ptoEmision, vehOnholdRow.nroRemito).subscribe({
        next: (response) => {
          this.notificationService.open(ErrorCodes.ONHOLD_RELEASE_SUCCESS, 'success');
          this.search();
        },
          error: (error) => {
          this.errors.push(error);
          this.notificationService.open(this.notificationService.getErrorByCode(error.error.errorCode), "error")
        }
      })
  }

  checkPrintExcel(noSearchCriteria: boolean){
    if(this.printExcel){
      this.vehicleOnHoldService.downloadOnHoldExcel(this.vehOnHold).subscribe({
        next: (response) => {
          if(response.size > 0){
            const newBlob = new Blob([response], {type: 'application/vnd.ms-excel'});
            const data = window.URL.createObjectURL(newBlob);
            const link = document.createElement('a');
            link.href = data;
            link.download = `Pendientes a liberar_` + this.formatDate(new Date()) + `.xlsx`;
            link.click();
            if(noSearchCriteria){
              this.notificationService.open("File downloaded successfully with all results.", 'success')
            }
            this.isLoading = false;
          }
        },
        error: (error) => {
          this.errors.push(error);
          this.notificationService.open(this.notificationService.getErrorByCode(error.errorCode), 'error')
          this.isLoading = false;
        }
      })
    }
    this.printExcel = false;
  }

  setPagination() {
    this.dataSource.paginator = this.paginator;
  }

  formatDate(date: Date) {
    let hours = date.getHours();
    let ampm = "AM";
    if (hours > 12) {
      hours = hours - 12;
      ampm = "PM"
    } else if (hours == 12) {
      ampm = "PM";
    } else if (hours == 0) {
      hours = 12;
    }
    return (
      [
        (date.getMonth() + 1).toString().padStart(2, '0'),
        (date.getDate()).toString().padStart(2, '0'),
        date.getFullYear(),
        hours.toString().padStart(2, '0'),
        (date.getMinutes()).toString().padStart(2, '0'),
        (date.getSeconds()).toString().padStart(2, '0') + ampm
      ].join('_')
    );
  }

  showError(results: OnHoldUploadResults){
    if (results.processingError.length === 0 && results.notFoundVinList.length === 0) {
      this.notificationService.open(ErrorCodes.FILE_UPLOAD_SUCCESS, "success");
      this.vehicleOnHoldService.getAllOnHoldRemitos(this.vehOnHold).subscribe((response) => {
        this.onholdItems = response;
        this.displayData();
      });
    }
    // Since max vin is restricted to 100, this message is no longer needed
    // else if(results.errorExceedLimit){
    //   this.notificationService.open(`${results.fullyError ? ErrorCodes.FILE_UPLOAD_NO_SUCCESS : ErrorCodes.FILE_UPLOAD_PROCESSED_PARTIALLY} ${ErrorCodes.FILE_UPLOAD_ERROR_EXCEED_LIMIT}`, 'error', 0);
    // }
    else {
      // Use dialog here to ensure all vins are display.
      this.openDialog(results);
      // this.notificationService.open('El archivo fue parcialmente procesado.', "error", 0);
    }
  }

  openDialog(results: OnHoldUploadResults) {
    this.dialog.open(PopupFileUploadMessageDialogComponent, {
      data: {
        type: SCREEN.onHold,
        results: results
      },
      maxWidth: 600
    });
  }

}
